/* eslint-disable no-console */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-nested-ternary */
import { axiosV1, axiosV2 } from 'interceptors/axios';
import types from 'redux/actions/actionTypes';
import alertBodyTypes from 'modules/_shared/components/Alert/alertBodyTypes';

import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';
import { countSocietyShares } from 'utils/getShareCount';
import { getSocietyDataByUser } from 'utils/societies';

import { addAlert } from '../../_shared/redux/alertActions';
import { uploadImage } from '../../_shared/api/imageActions';

export const fastUpdateSociety = async (societyId, updateSocietyData) => {
  const body = {
    _id: societyId,
    ...updateSocietyData,
  };
  try {
    await axiosV1.put(`/societies`, body);
  } catch (error) {
    console.log(error);
  }
};

export function setSociety(result, user, updateActivePartners = true) {
  if (result) {
    const actualSociety = countSocietyShares(result?.society);

    if (updateActivePartners && actualSociety) {
      const activePartners = actualSociety?.partners?.filter(
        (partner) => partner?.sharesCount?.actual > 0
      ).length;

      actualSociety.activePartners = activePartners || 0;
      fastUpdateSociety(actualSociety['_id'], { activePartners });
    }

    const society = getSocietyDataByUser(actualSociety, user);

    return {
      type: types.SET_SOCIETY,
      society: { ...result, society },
    };
  }

  return {
    type: types.DELETE_SOCIETY,
  };
}

export function reSetSociety(society) {
  if (!society) return;

  const updatedSociety = countSocietyShares(society);
  const activePartners = updatedSociety?.partners.filter(
    (partner) => partner?.sharesCount?.actual > 0
  ).length;

  updatedSociety.activePartners = activePartners || 0;
  fastUpdateSociety(updatedSociety['_id'], { activePartners });

  return { type: types.UPDATE_SOCIETY, society: updatedSociety };
}

export const setBasicSociety = (society) => {
  if (!society) return;

  return {
    type: types.UPDATE_SOCIETY,
    society,
  };
};

export const createSociety =
  (society, showAlert = true, dispatchForUser = true) =>
  async (dispatch) => {
    try {
      const { data } = await axiosV2.post(`/societies`, society);

      const decodedData = await decryptResponse(data);

      if (dispatchForUser) {
        dispatch({ type: types.CREATE_SOCIETY, society: decodedData['_id'] });
      }

      if (showAlert) {
        dispatch(addAlert(alertBodyTypes.SOCIETY_ADDED));
      }

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };

export const setSocietyForUser = (societyId) => async (dispatch) => {
  try {
    if (societyId) {
      dispatch({ type: types.CREATE_SOCIETY, society: societyId });
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateSociety =
  (societyId, updateSocietyData, showAlert = true) =>
  async (dispatch) => {
    const body = {
      _id: societyId,
      ...updateSocietyData,
    };
    try {
      const { data } = await axiosV1.put(`/societies`, body);

      const decodedData = await decryptResponse(data);

      if (decodedData) {
        dispatch(reSetSociety(decodedData));
      }

      if (showAlert) {
        dispatch(addAlert(alertBodyTypes.SOCIETY_UPDATED));
      }
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };

export const deleteSocietyById = (society) => async (dispatch) => {
  try {
    const { data } = await axiosV1.delete(`/societies/${society}`);

    const decodedData = await decryptResponse(data);

    dispatch({ type: types.DELETE_SOCIETY, society: decodedData['_id'] });

    dispatch(addAlert(alertBodyTypes.SOCIETY_DELETED));

    return decodedData['_id'];
  } catch (error) {
    return dispatchError(error, dispatch);
  }
};

export async function getSocietyById(societyId) {
  const query = { params: { societyId } };
  try {
    const { data } = await axiosV1.get(`/societies/`, query);

    const decodedData = await decryptResponse(data);
    return decodedData;
  } catch (error) {
    return { name: '' };
  }
}

export async function getHolderSocieties(
  holderId,
  userId,
  filterBy = 'ALL',
  setter
) {
  const query = { holder: holderId, holderUserId: userId, filterBy };

  try {
    const { data } = await axiosV2.get(`/societies`, {
      params: query,
    });

    const decodedData = await decryptResponse(data);
    if (setter) setter(decodedData);
    return decodedData;
  } catch (error) {
    console.log(error);
  }
}

export async function getUserSocieties(userId, role = 'admin', setter, source) {
  let query;

  const roleKeyMap = {
    admin: 'admin',
    partner: 'partner',
    beneficiary: 'beneficiary',
    investor: 'investor',
    holder: 'holder',
    partnerRepresentant: 'partnerRepresentant',
    guest: 'guest',
    director: 'director',
  };

  const key = roleKeyMap[role];

  const rolesApiV2 = [
    'admin',
    'beneficiary',
    'partner',
    'partnerRepresentant',
    'guest',
    'director',
  ];

  const axiosInstance = rolesApiV2.includes(role) && source ? axiosV2 : axiosV1;

  if (key) {
    query = { [key]: userId, source, user: userId };
  }

  try {
    // const { data } = await axiosV1.get(`${baseURL}/societies`, {
    //   params: query,
    // });

    const { data } = await axiosInstance.get('/societies', {
      params: query,
    });

    const decodedData = await decryptResponse(data);

    if (setter) setter(decodedData);
    return decodedData;
  } catch (error) {
    return { name: '' };
  }
}

export async function getUserTransactions(userId, setter) {
  const query = { transactions: true, admin: userId };
  try {
    const { data } = await axiosV1.get(`/societies`, {
      params: query,
    });

    const decodedData = await decryptResponse(data);
    if (setter) setter(decodedData);
    return decodedData;
  } catch (error) {
    return { name: '' };
  }
}

export const getSocietiesRegistered = async (name) => {
  try {
    const { data } = await axiosV1.get(`/registered/${name}`);

    const decodedData = await decryptResponse(data);

    const societies = await decodedData?.organisations?.map((society) => ({
      label: society.nameAddress.name,
      nameAddress: society.nameAddress,
      activity: society.activity,
      registeredOffice: society.registeredOffice,
    }));

    return societies;
  } catch (error) {
    return [];
  }
};

export const updateSocietyTheme =
  (societyId, updateSocietyData, showAlert = false) =>
  async (dispatch) => {
    const body = {
      _id: societyId,
      customization: {
        updateData: {
          theme: {
            ...updateSocietyData,
          },
        },
      },
    };

    try {
      if (updateSocietyData.logo instanceof File) {
        const logoData = await uploadImage(updateSocietyData.logo);
        body.customization.updateData.theme.logo = logoData;
      }

      if (updateSocietyData.emailFrameLogo instanceof File) {
        const emailFrameLogoData = await uploadImage(
          updateSocietyData.emailFrameLogo
        );
        body.customization.updateData.theme.emailFrameLogo = emailFrameLogoData;
      }

      const { data } = await axiosV2.put(`/societies`, body);

      const decodedData = await decryptResponse(data);
      dispatch(reSetSociety(decodedData));

      if (showAlert) {
        dispatch(addAlert(alertBodyTypes.SOCIETY_UPDATED));
      }
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };

export const updateSocietyConfiguration =
  (societyId, updateSocietyData, showAlert = false) =>
  async (dispatch) => {
    const body = {
      _id: societyId,
      configuration: {
        updateData: { ...updateSocietyData },
      },
    };

    try {
      const { data } = await axiosV2.put(`/societies`, body);

      const decodedData = await decryptResponse(data);
      dispatch(reSetSociety(decodedData));

      if (showAlert) {
        dispatch(addAlert(alertBodyTypes.SOCIETY_UPDATED));
      }
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
